<template>
  <div class="mask" v-if="TopnavMsg.isVersionSwitchNew">
    <div class="switch-version-p">
      <i class="close-icon iconfont iconguanbianniu2" @click="onClose"></i>
      <div class="version-text">
        体验新版编辑器将不会影响当前的草稿内容，数据已进行备份，您可在草稿箱找到它。
      </div>
      <!-- <div class="version-tips">
        <i class="iconfont icontishijingshi"></i>
        <p>请注意：进入内测编辑器创建编辑的内容将无法在旧版编辑器打开。</p>
      </div> -->
      <div class="switch-version-b" @click="onconfirm">了解，切换新版</div>
      <div class="version-check">
        <el-checkbox v-model="isCheck"></el-checkbox>
        <span>之后不再提示</span>
      </div>
    </div>
  </div>
</template>
  <script>
import { mapGetters } from 'vuex';
export default {
  name: "SwitchVersion",
  data() {
    return {
      isCheck: false
    };
  },
  computed: {
    ...mapGetters([
      'TopnavMsg'
    ])
  },
  methods: {
    onClose() {
      this.$store.commit('save_TopnavMsg', {
        isVersionSwitchNew: false
      });
    },
    onconfirm() {
      this.$message({
        message: "正在切换，请稍等...",
        type: "success",
        duration: 3
      });
      if (this.isCheck) {
        window.localStorage.setItem("isVersionSwitchNew", "true");
      }
      sensors.track('laipicBetaVersionSwap', {
        swap_type: this.TopnavMsg.versionSwitchNewType,
        version: '5.6.3'
      });
      window.localStorage.setItem("isToNewVersion", "true");
      localStorage.setItem('isNewTool', '1');
      // window.location.href = `${window.location.origin}/newtool/`;
      this.$http
        .post("/api/user/draft/copy", {
          id: window.location.hash.slice(2),
        })
        .then((res) => {
          if (res.data.code === 200) {
            const copyDraftId = res.data.data.uid;
            const donggang = location.href.indexOf("donggang=true");
            if (donggang !== -1) {
              window.open(`${ window.location.origin }/newtool/?donggang=true#/${ copyDraftId }`);
            } else {
              window.open(`${ window.location.origin }/newtool/#/${ copyDraftId }`);
            }
            //  window.location.href = `${window.location.origin}/newtool/#/${copyDraftId}`;
            console.log(`Turbo ~ .then ~ window:`, window);
          } else if (res.data.code === 412) {
            this.onClose();
            this.$memberGuide({
              show: true,
              context: this,
              funcRight: {
                type: "draftNumber",
                name: "草稿数量",
              },
            });
          }
        });
        this.onClose();
    }
  }
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
}
.switch-version-p {
  width: 500px;
  // height: 282px;
  background-color: #ffffff;
  position: relative;
  border-radius: 4px;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -250px;
  padding: 48px 32px 36px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  .version-text {
    text-align: left;
    line-height: 24px;
    margin-bottom: 11px;
    font-size: 16px;
  }
  .version-check {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-checkbox {
      margin-right: 8px;
    }
    // >span{
    //   margin-left: 8px;
    // }
  }
  .version-tips {
    display: flex;
    color: #666a80;
    line-height: 21px;
    > i {
      margin-right: 9px;
      color: #fa8c16;
    }
  }
  .switch-version-b {
    width: 152px;
    margin: 24px auto 20px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    color: #ffffff;
    background-color: #6464f8;
  }
  .close-icon {
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
    transform: scale(0.7);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/switchVersion.vue